<template>
  <div>
    <!-- eslint-disable vue/no-parsing-error -->
    <Link :underline="false" class="nav-close" @click="closeSlider">
      <svgicon name="cancelwhite" width="12" height="12" :original="true" @click="closeSlider" />
    </Link>
    <div class="drawer-header text-lowercase">
      <span v-if="showAddForm" @click="closeSlider"></span>
      <span v-else>
        <span v-if="isShipToView">{{$t('INDENT_SELECT_DROP_OFFS')}}</span>
        <span v-else>{{$t('INDENT_CHANGE_SOLD_TO')}}</span>
        <span v-if="selectedPickupData.name"> for {{selectedPickupData.name}}</span>
      </span>
      <div class="header-action">
        <Button type="text" size="mini" class="button-text-blue" @click="closeSlider">{{$t('INDENT_CANCEL')}}</Button>
        <Button type="primary" size="mini" @click="addAll">{{$t('INDENT_ADD')}}</Button>
      </div>
    </div>
    <div class="drawer-body pt-0">
      <div v-if="showAddForm">
        <h4 class="drawer-title">{{$t('INDENT_NEW_CONSIGNEE')}}</h4>
        <Form :inline="true" class="form-default form-triple">
          <FormItem :label="$t('INDENT_CONSIGNEE_NAME')" required>
            <Input :placeholder="$t('INDENT_ENTER_CONSIGNEE_NAME')" v-model="consignee.name"></Input>
          </FormItem>
          <FormItem :label="$t('INDENT_REFERENCE_ID')" required :disabled="configurations.auto_generate_consigee_ref_id">
            <Input :placeholder="$t('INDENT_ENTER_REF_ID')" v-model="consignee.reference_id"
            ></Input>
          </FormItem>
          <FormItem :label="$t('INDENT_EMAIL_ADDRESS')">
            <Input :placeholder="$t('INDENT_ENTER_EMAIL_ADDRESS')" v-model="consignee.email_id"></Input>
          </FormItem>

          <FormItem :label="$t('INDENT_CITY')" required>
            <Input :placeholder="$t('INDENT_ENTER_CITY_NAME')" v-model="consignee.city"></Input>
          </FormItem>
          <FormItem :label="$t('INDENT_STATE')" required>
            <Input :placeholder="$t('INDENT_ENTER_STATE_NAME')" v-model="consignee.state"></Input>
          </FormItem>
          <FormItem :label="$t('INDENT_REGION')" required>
            <Input :placeholder="$t('INDENT_ENTER_REGION')" v-model="consignee.region"></Input>
          </FormItem>
          <FormItem :label="$t('INDENT_PINCODE')" required>
            <Input :placeholder="$t('INDENT_ENTER_PIN_CODE')" v-model="consignee.pincode" @input="autoPopulateRatecard"></Input>
          </FormItem>
          <FormItem :label="$t('INDENT_ADDRESS')">
            <Input :placeholder="$t('INDENT_ENTER_ADDRESS')" v-model="consignee.address"></Input>
          </FormItem>
          <FormItem :label="$t('INDENT_PHONE_NUMBER')" :required="isPhoneRequired">
            <Input :placeholder="$t('MDM_ENTER_PHONE_NUMBER')" type="number" v-model="consignee.phone"></Input>
          </FormItem>
        </Form>
      </div>
      <div v-else class="splitter">
        <div class="splitter-left">
          <ElTabs
            class="tab-default tab-sm tab-bg"
            v-model="activeTab"
            @tab-click="callGA('Switch');loadDestinationData()"
          >
            <Tab-pane
              v-for="(config,index) in destinationConfig"
              :key="index"
              :label="$t(config.tlabel)"
              :name="config.type.toString()"
              :disabled="!isShipToView && config.type.toString() !== activeTab"
            >
              <div :class="['tab-content', {'bg-grey-lighter':!isShipToView}]">
                <h5 class="drawer-sub-title mt-0">
                  <i v-if="isShipToView" class="icon-rounded bg-orange-light">
                    <svgicon name="icon-vehicle" width="15" height="15" />
                  </i>
                  <i v-else class="icon-rounded bg-green-light1">
                    <svgicon name="icon-currency" width="15" height="15" />
                  </i>
                  <span v-if="isShipToView">{{$t('INDENT_SHIPPED_TO')}}</span>
                  <span v-else>{{$t('INDENT_SOLD_TO')}}</span>
                  <div class="f-right" v-if="config.addOnCreate" @click="showAddForm = true">
                    <Link :underline="false" class="link-action">
                      <svgicon name="add" width="11" height="11" :original="true" />
                      {{config.label}}
                    </Link>
                  </div>
                </h5>
                <div @click="callGA('Search')">
                  <Input
                    :placeholder="`Search by ${config.label} Name, City or ID`"
                    size="mini"
                    v-model="searchText"
                    @input="searchDrop"
                    class="input-search"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </Input>
                </div>
                <div class="status-msg" v-if="isLoading && !list.length">
                  <span>
                    <img :src="Indent" width="170" height="130" alt=""/>
                  </span>
                </div>
                <Table
                  v-else
                  :data="destinationList"
                  :stripe="true"
                  :max-height="windowHeight"
                  align="top"
                  class="table-striped bordered mt-10"
                  aria-describedby="destinationListData"
                >
                  <table-column width="35">
                    <template slot-scope="scope">
                      <Checkbox
                        v-if="isShipToView"
                        :disabled="!isShipToSelected(scope.row.id) && (maxSelectionAllowed <= selectedDrops.length)"
                        :value="isShipToSelected(scope.row.id)"
                        @change="addEditDrop(scope.row, $event)"
                      ></Checkbox>
                      <Radio
                        v-else
                        :value="isSoldToSelected(scope.row.id)"
                        :label="scope.row.id"
                        @change="addEditDrop(scope.row, true)"
                      ></Radio>
                    </template>
                  </table-column>
                  <TableColumn :label="$t('INDENT_LABEL_NAME_REF_ID', {label: $t(config.tlabel)})">
                    <template slot-scope="scope">
                      <span class="d-block">
                        <Ellipsis
                          v-if="scope.row.name"
                          :text="scope.row.name"
                          length="30"/>
                      </span>
                      <span class="text-xs">
                        <Ellipsis
                          v-if="scope.row.reference_id"
                          :text="scope.row.reference_id"
                          length="30"/>
                      </span>
                    </template>
                  </TableColumn>
                  <TableColumn :label="$t('INDENT_LABEL_CITY', {label: $t(config.tlabel)})">
                    <template slot-scope="scope">
                      <Ellipsis
                        v-if="scope.row.city"
                        :text="scope.row.city"
                        length="30"/>
                    </template>
                  </TableColumn>
                  <infinite-loading
                    v-if="!hasEmpty"
                    slot="append"
                    @infinite="loadData"
                    force-use-infinite-wrapper=".el-table__body-wrapper"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                  </infinite-loading>
                </Table>
              </div>
            </Tab-pane>
          </ElTabs>
        </div>

        <div :class="['splitter-right', {'bg-white':!isShipToView}]">
          <h5 class="drawer-sub-title mt-0">
            {{$t('INDENT_SELECTED_DROPOFFS')}}
          </h5>
          <div class="status-msg top-align my-md" v-if="noDropsPresent">
            <span>
              <svgicon name="empty-dropoffs-selected" width="125" height="95" :original="true" />
              <p class="text-normal text-xs"> {{$t('INDENT_NO_DROPOFFS_SELECTED')}}</p>
            </span>
          </div>
          <div class="drawer-scroll" v-else>
            <div
              v-for="(drop,index) in selectedDrops"
              :key="index" class="selected-group"
              :class="{'is-selected':!isShipToView}"
              @click ="currentSelectedShipToId = drop.indexedAt"
            >
              <span class="group-name">{{getTypeConfig(drop.ship_to.type).label}}</span>
              <div class="custom-popover" v-if="showDeletePrompt &&
                drop.indexedAt === currentSelectedShipToId"
              >
                {{$t('INDENT_DELETE_DROPOFF')}}?
                <span class="text-bold ml-10">
                  <span class="d-inline pointer" @click="addEditDrop(drop.ship_to, false)">{{$t('INDENT_YES')}}</span>
                  /
                  <span class="d-inline pointer" @click="showDeletePrompt = false">{{$t('INDENT_NO')}}</span>
                </span>
              </div>
              <span
                class="action-icon"
                v-if="(!isShipToView && drop.indexedAt=== currentSelectedShipToId) || isShipToView"
              >

                <Tooltip :open-delay="100" effect="dark" placement="bottom-end" class="mr-10">
                  <div slot="content">Clone</div>
                  <i @click="cloneDrop(drop)">
                    <svgicon name="icon-clone-md" width="14" height="14" />
                  </i>
                </Tooltip>

                <Tooltip :open-delay="100" effect="dark" placement="bottom-end" v-if="isShipToView">
                  <div slot="content">{{$t('INDENT_SWITCH_SOLD_TO')}}</div>
                  <i @click="switchSoldtoView(drop)">
                    <svgicon name="icon-edit-md" width="14" height="14" />
                  </i>
                </Tooltip>

                <i
                  class="action-cancel"
                  @click="switchShiptoView"
                  v-else-if="drop.indexedAt === currentSelectedShipToId"
                >
                  <svgicon name="icon-close" width="10" height="10" />
                </i>
              </span>
              <div class="selected-item">
                <span class="icon-list">
                  <svgicon name="icon-vehicle" width="15" height="15" />
                </span>
                <div class="content">
                  <div>{{drop.ship_to.name}}</div>
                  <small>{{drop.ship_to.reference_id}}</small>
                </div>
              </div>
              <div
                class="selected-item"
                :class="{'is-active': !isShipToView && drop.indexedAt === currentSelectedShipToId}"
              >
                <span class="icon-list">
                  <svgicon name="icon-currency" width="15" height="15" />
                </span>
                <div class="content">
                  <div>{{drop.sold_to.name}}</div>
                  <small>{{drop.sold_to.reference_id}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { debounce } from 'debounce';
import { uniq } from 'lodash';

import { sourceAndDestinationType } from 'pando-constants';
import { orderTypes, mandatoryConsigneeFields } from '@/modules-v2/indent/constants/order';

import Indent from '@common/asset/images/Indent.gif';
import { isOpen, isContract } from '@common/lib/order';

import ContractCheck from '@/modules-v2/indent/mixins/create-update/contract-check';
import { customerTypeMapper } from '@/constants/mdm-v2/consignee';

export default {
  mixins: [ContractCheck],
  props: {
    data: {
      default: () => [],
      type: Array,
    },
    destinationConfig: {
      default: () => [],
      type: Array,
    },
    sourceId: {
      default: '',
      type: String,
    },
    selectedPickupData: {
      default: () => ({}),
      type: Object,
    },
    sourcesDropOffs: {
      default: () => [],
      type: Array,
    },
    orderType: {
      default: '',
      type: String,
    },
    skipContractCheck: {
      default: false,
      type: Boolean,
    },
    maxSelectionAllowed: {
      type: Number,
    },
  },
  data() {
    return {
      Indent,

      // temporary variable to hold the drops before saving
      selectedDrops: [],

      // manage ship to sold to switch
      isShipToView: true,
      currentSelectedShipToId: null,

      activeTab: 0,
      searchText: null,
      sourceAndDestinationType,

      showSwitchToOpenDialog: false,
      showDeletePrompt: false,

      currentContractVehicles: [],

      showAddForm: false,
      consignee: {
        name: null,
        reference_id: '',
        address: '',
        city: null,
        state: null,
        country: 'India',
        pincode: '',
        combine: true,
        category: '',
        status: 1,
        exclude_vehicles_list: [],
        region: '',
        manager: '',
        email_id: '',
        sales_email: '',
        sales_name: '',
        sales_phone: '',
        group: '',
        phone: '',
        delivery_do_not_combine: false,
        overseas_customer: false,
        ports_associated: [],
        loading_time: {},
        unloading_time: {},
      },
    };
  },
  created() {
    this.selectedDrops = [...this.data];
    this.selectedDrops.forEach((drop) => {
      drop.indexedAt = (Math.random() + 1).toString(36).substring(7);
    });
    this.activeTab = this.destinationConfig[0].type.toString();
    this.loadDestinationData();
  },
  computed: {
    ...mapGetters({
      currentUser: 'app/currentUser',
      list: 'indentV2/list',
      isLoading: 'indentV2/isLoading',
      filter: 'indentV2/filter',
      hasEmpty: 'indentV2/hasEmpty',

      configurations: 'app/configurations',
    }),
    currentOrderTypeConfig() {
      const config = orderTypes.find(val => val.name === this.orderType);
      return (config && config.dropoffs_columns_config) || {};
    },
    noDropsPresent() {
      return !this.selectedDrops || !this.selectedDrops.length;
    },
    windowHeight() {
      return `${window.innerHeight - 250}px`;
    },
    isContract() {
      return this.orderType === 'CONTRACT';
    },
    destinationList() {
      const selectedTab = this.activeTab;
      let resultList = [];
      switch (parseInt(selectedTab, 10)) {
        case this.sourceAndDestinationType.DEPOT:
          this.list && this.list.forEach((source) => {
            resultList.push({
              city: source.gate.city,
              name: source.name,
              reference_id: source.gate.reference_id,
              id: source.gate.id,
              location_id: source.id, // depot id
            });
          });
          break;
        case this.sourceAndDestinationType.CONSIGNEE:
          resultList = [...this.list];
          break;
        default:
          break;
      }
      return resultList.filter(val => val.id !== this.selectedPickupData.id);
    },
    isPhoneRequired() {
      return this.configurations.consignee_otp_for_grn || false;
    },
  },
  methods: {
    callGA(type) {
      const selectedTab = parseInt(this.activeTab, 10);
      const config = this.getTypeConfig(selectedTab);
      if (config.GAEventConstants) {
        const gaEvents = [...config.GAEventConstants];
        gaEvents[1] = `${type} ${gaEvents[1]}`;
        this.$emit('setGA', ...gaEvents);
      }
    },

    closeSlider() {
      if (this.showAddForm) {
        this.showAddForm = false;
      } else {
        this.$emit('closeDropoffSlider');
      }
    },
    addAll() {
      if (this.showAddForm) {
        this.addConsignee();
      } else {
        if (this.hasDuplicateDrops(this.selectedDrops)) {
          this.$errorMessage({ message: 'Drop-off(s) contains duplicate entries' });
          return;
        }
        this.$emit('addEditDropoffs', this.selectedDrops);
        if (this.isContract && !this.skipContractCheck) {
          this.$emit('changeContractVehicles', this.currentContractVehicles);
        }
      }
    },
    /**
     * @method hasDuplicateDrops
     * @param Array
     * Check for duplicate drop entries
     */
    hasDuplicateDrops(selectedDrops) {
      const checkList = selectedDrops.map(drop => `${drop.ship_to.id}${drop.sold_to.id}`);
      const checkSet = uniq(checkList);
      return checkList.length !== checkSet.length;
    },
    /**
     * SHIP TO related methods
     */
    isShipToSelected(id) {
      return (
        this.selectedDrops &&
        this.selectedDrops.some(val => val && val.ship_to.id === id)
      );
    },

    /**
     * SOLD TO related methods
     */
    isSoldToSelected(id) {
      const index = this.selectedDrops.findIndex(
        val => val.indexedAt === this.currentSelectedShipToId,
      );
      return index !== -1 && this.selectedDrops[index].sold_to.id === id && id;
    },

    // switch SHIP TO and SOLD TO view
    switchShiptoView(ship_to_id = null) {
      this.currentSelectedShipToId = ship_to_id;
      this.isShipToView = true;
    },

    switchSoldtoView(drop) {
      if (this.activeTab !== drop.ship_to.type.toString()) {
        this.activeTab = drop.ship_to.type.toString();
        this.loadDestinationData();
      }
      this.currentSelectedShipToId = drop.indexedAt;
      this.isShipToView = false;
    },

    // add/delete ship to
    // edit sold to
    async addEditDrop(dropData, value) {
      try {
        const dropObj = {
          type: parseInt(this.activeTab, 10),
          id: dropData.id, // gate id
          location_id: dropData.location_id, // depot id
          name: dropData.name,
          reference_id: dropData.reference_id,
        };
        if (value) {
          if (this.isShipToView) {
            // selecting a ship to
            let contractCheck = true;
            // const skipContractApplicable = !this.$hasFeature('update_indent_status_for_non_contracted_dropoff') ? !this.skipContractCheck : true;
            if (this.isContract && !this.skipContractCheck) { // check contract only for contract indents
              contractCheck = await this.checkContract(dropObj);
            }
            let userResponse = false; // default option: donot switch to open
            if (!contractCheck) { // no contract switch to open popup
              userResponse = await this.openSwitchOpenIndentDialog();
              if (userResponse) {
                this.$emit('reset-freight');
              }
            }
            if (contractCheck || userResponse) {
              const destinationObj = {
                ship_to: dropObj,
                sold_to: dropObj,
                indexedAt: (Math.random() + 1).toString(36).substring(7),
              };
              if (userResponse || !this.currentOrderTypeConfig.hide_unloaders) {
                destinationObj.unloader_available = false;
              }

              if (userResponse || !this.currentOrderTypeConfig.hide_paid_by) {
                destinationObj.add_to_invoice = false;
              }
              if (!isOpen(this.orderType) && !this.isContract) {
                destinationObj.expected_date = this.selectedPickupData.vehicle_requirement_date ?
                  moment(this.selectedPickupData.vehicle_requirement_date).startOf('day').add('days', 1) :
                  moment().startOf('day').add('days', 1);
              }
              this.selectedDrops.push(destinationObj);
            }
          } else {
            const index = this.selectedDrops.findIndex(
              val => val.indexedAt === this.currentSelectedShipToId,
            );
            // selecting a sold to
            this.selectedDrops[index].sold_to = dropObj;
            this.switchShiptoView();
          }
        } else {
          // removing a destination based on SHIP TO data
          this.selectedDrops = this.selectedDrops.filter(
            val => val.ship_to.id != dropObj.id,
          );
          if (this.isContract && this.selectedDrops.length) {
            await this.checkContract();
          } else {
            await this.changeContractVehicles([]);
          }
          this.showDeletePrompt = false;
          this.switchShiptoView();
        }
      } catch (error) {
        this.$errorMessage({
          message: this.$getErr('ACTION_ERR'),
        });
      }
    },

    cloneDrop(dropData) {
      this.selectedDrops.push({ ...dropData, indexedAt: (Math.random() + 1).toString(36).substring(7) });
    },
    // call the destination data w.r.t the selected tab
    // switch tab method call
    async loadDestinationData() {
      this.searchText = null;
      this.$store.commit('indentV2/resetListing');
      this.loadData();
    },

    // search for destination
    searchDrop: debounce(async function () {
      this.$store.commit('indentV2/resetListing');
      this.loadData();
    }, 300),

    async loadData($state = null) {
      const selectedTab = parseInt(this.activeTab, 10);
      let params = { ...this.filter };
      switch (parseInt(selectedTab, 10)) {
        case this.sourceAndDestinationType.DEPOT:
          params = {
            filters: {
              ...params,
              type: this.sourceAndDestinationType.DEPOT,
            },
          };
          break;
        case this.sourceAndDestinationType.CONSIGNEE:
          params = {
            id: this.currentUser.id,
            filters: {
              ...params,
            },
          };
          break;
        default:
          break;
      }
      if (this.searchText) {
        params.filters.query = this.searchText;
      }
      const config = this.getTypeConfig(selectedTab);
      await this.$store.dispatch(config.storeCallPath, params);

      if ($state) {
        if (!this.hasEmpty) {
          $state.loaded();
        }
      }
    },

    getTypeConfig(type) {
      return this.destinationConfig.find(val => val.type === parseInt(type));
    },

    setOrderType(orderType) {
      this.$emit('setOrderType', orderType);
    },

    changeContractVehicles(data) {
      this.currentContractVehicles = data;
    },

    /**
     * add form
     */
    async addConsignee() {
      const consigneeEntries = Object.entries(this.consignee);
      const formCheck = consigneeEntries.length && Object.entries(this.consignee).filter(field => mandatoryConsigneeFields.includes(field[0])).every(detail => detail[1]);
      if (formCheck) {
        this.consignee.customer_type = customerTypeMapper.DISTRIBUTOR;
        const result = await this.$store.dispatch('indentV2/addConsignee', this.consignee);
        if (!result || result.error) {
          this.$errorMessage({ message: result.error });
        } else {
          await this.addEditDrop(result, true);
          this.$successMessage({ message: 'Consignee added successfully!' });
          this.closeSlider();
        }
      } else {
        this.$errorMessage({ message: 'Please enter all the mandatory details' });
      }
    },
    autoPopulateRatecard: debounce(async function debounceSearch($event) {
      try {
        if (this.configurations && this.configurations.autopopulate_pincode_ratecard) {
          if ($event && $event.length === 6) {
            const pincodeValue = parseInt($event, 10);
            const result = await this.$store.dispatch('mdm/fetchPincodeRatecard', pincodeValue);
            if (result && !result.error) {
              this.consignee.state = result.state;
              this.consignee.region = result.region;
              this.consignee.city = result.city;
              this.consignee = { ...this.consignee };
            }
          }
        }
      } catch (err) {
      }
    }, 500),

  },
};
</script>

